import {useLocalStorage} from "../../hooks/useLocalStorage";

export function useServerId(): string | null {
    const [serverId, _setServerId] = useLocalStorage("serverId");
    return serverId;
}